<div class="container-box shadow-none">
  <div class="d-flex gap-3 align-items-center p-3">
    <img src="/assets/images/channel-wizards/listing-icon2.webp" alt="" height="40" />
    <div>
      <h6 class="mb-0">Rates</h6>
      <div class="text-sm">
        <ng-container i18n
          >As mentioned previously in this connection wizard, rates will now need to be pushed from AdvanceCM to
          Expedia.</ng-container
        >
        <br />
        <ng-container i18n
          >Until this is done, your availability will remain blocked and the connection will not be
          complete.</ng-container
        >
      </div>
    </div>
  </div>
  <div class="border-top p-4 d-flex gap-5">
    <div class="flex-fill">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true" #settings>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">1</div>
              <ng-container i18n>Add Rates</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>
              As mentioned previously in this connection wizard, rates will now need to be pushed from AdvanceCM to
              Expedia. Until this is done, your availability will remain blocked and the connection will not be
              complete.
            </p>

            <p i18n>
              If you have already prepared rates which you want to push to Expedia please hit Continue to proceed.
            </p>
            <div class="d-flex align-items-center gap-3">
              <button class="btn btn-light-info" (click)="onAddStandardRate()">
                <i class="far fa-plus"></i> <ng-container i18n>Add Standard Rate</ng-container>
              </button>
              <button class="btn btn-light-info" (click)="onAddDynamicRate()">
                <i class="far fa-plus"></i> <ng-container i18n>Add Dynamic Rate</ng-container>
              </button>
              <div class="flex-fill"></div>
              <button class="btn btn-light-info" (click)="pushRates.open()">
                <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
              </button>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel #pushRates>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">2</div>
              <ng-container i18n>Push Rates</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>
              This section will push the rates prepared by you previously to Expedia. After completing this step you
              should see both the availability and rates match with your Expedia rates calendar.
            </p>

            <p i18n>
              After clicking the Push Rates button you will be asked to specify the AdvanceCM Rate Category and the
              Channel Rate Category.
            </p>

            <p i18n>Here is a quick explanation of both values.</p>

            <div i18n class="text-semi-bold">AdvanceCM Rate Category:</div>
            <p i18n>
              This corresponds with the rate category you have created or selected when creating your rates in
              AdvanceCM.
            </p>

            <div i18n class="text-semi-bold">Channel Rate Category:</div>
            <p i18n>
              This corresponds with the rate name in Expedia. By default the name of this rate will be Standard, but it
              is possible that you have renamed the standard rate in Expedia and you will instead see that rate plan
              name as an option.
            </p>
            <div class="d-flex align-items-center gap-3">
              <button class="btn btn-light-info" (click)="onPushRates()">
                <i class="cs-icon cs-icon-upload"></i> <ng-container i18n>Push Rates</ng-container>
              </button>
              <div class="flex-fill"></div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<div class="mt-3 d-flex align-items-center justify-content-between">
  <button class="btn btn-outline-light" (click)="prev.emit()">
    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
    <ng-container i18n>Previous</ng-container>
  </button>
  <button class="btn btn-secondary-info" (click)="next.emit()">
    <ng-container i18n>Next</ng-container>
    <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
  </button>
</div>
